import React from 'react';
/* eslint-disable */
export const TwoToFourHours = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="55"
    viewBox="0 0 45 45"
    style={{ marginRight: '5px' }}
    data-testid="two-to-four-hours"
  >
    <g fill="none" fillRule="nonzero" stroke="#333" transform="translate(0 3)">
      <circle cx="17.5" cy="17.5" r="16.739" fill="#FFF" />
      <path fill="#F26422" d="M17.5 17.5V.76a16.74 16.74 0 0 1 7.791 1.918L17.5 17.5z" />
    </g>
  </svg>
);
